import React, {Fragment} from 'react';
import {connect} from 'react-redux'
import FormDeviseWorkContainer from './FormDeviseWorkContainer'
import {checkAuthAction} from "../../actions";
import {Layout, Card} from 'antd';

const {Header} = Layout;

class DefaultDeviseTemplateContainer extends React.Component {

    componentWillMount() {
        this.props.checkAuthAction()
    }

    render() {
        return (
            <FormDeviseWorkContainer
                fromWorkMain={this.htmlBody()}
            />

        )
    }

    htmlBody() {
        return (
            <Fragment>
                {this.props.title ?
                    <Header style={{background: '#fff', padding: 0}}>
                        <h1 className=''>
                            {this.props.title}
                            <span style={{float: 'right'}}>
                            {this.props.menuButton}
                            </span>
                        </h1>
                    </Header> : ''
                }
                <Card bordered={false} style={{minHeight: '100vh'}}>
                    {this.props.htmlBody}
                </Card>
            </Fragment>
        )
    }


}

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToPorps = (dispatch) => ({
    checkAuthAction: (transfer) => (
        dispatch(checkAuthAction(dispatch, transfer))
    )
})

export default connect(mapStateToProps, mapDispatchToPorps)(DefaultDeviseTemplateContainer)


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/DefaultDeviseTemplateContainer/DefaultDeviseTemplateContainer.jsx